import React from "react";
import "../css/dotNetHeader.css";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/autoplay";
import { Pagination, Autoplay } from "swiper/modules";
import { Link } from "react-router-dom";

const UiuxHeader = () => {
  const employeeList = [
    {
      id: 1,
      empImage: "/assets/blazordev.jpg",
      empName: "Qaiser Mehmood",
      empRole: "Senior UI/UX Developer",
    },
    {
      id: 2,
      empImage: "/assets/randomUser.png",
      empName: "Ahmad Ali",
      empRole: "UI/UX Developer",
    },
    {
      id: 2,
      empImage: "/assets/randomUser.png",
      empName: "Adeel Baig",
      empRole: "UI/UX Developer",
    },
  ];
  return (
    <div className="dotNetHeader">
      <div className="dotNetHeader-content">
        <h1 className="dotNetHeader_we">
          <span style={{ color: "#0F4C81" }}>UI/UX Designers Available</span>
        </h1>
        <div className="dotNetHeader_create-section">
          <div className="dotNetHeader_content_para">
            Over the past 30 years, 92 logics has developed over 100 mobile apps
            for clients across the U.S. Our team of designers develop
            user-friendly, intuitive, easy-to-navigate, and high-performance iOS
            and Android apps that help your business grow.
          </div>
          <div className="dotNetHeader_content_btn">
            <Link to="/hire" className="dotnet_hire_btn">
              Hire a Developer
            </Link>
          </div>
        </div>
      </div>

      <Swiper
        pagination={{
          dynamicBullets: true,
        }}
        modules={[Pagination, Autoplay]}
        autoplay={true}
        className="dotNetHeader-image"
      >
        {employeeList.map((emp) => (
          <SwiperSlide key={emp.id}>
            <img src={emp.empImage} />
            <div className="person_name">{emp.empName}</div>
            <div className="person_role">{emp.empRole}</div>
          </SwiperSlide>
        ))}
      </Swiper>
    </div>
  );
};

export default UiuxHeader;
